export default [
  {
    name: 'my',
    path: '/my',
    component() {
      return import('@/pages/my/Index.vue')
    },
  },
  {
    name: 'my/store/register',
    path: '/my/store/register',
    component() {
      return import('@/pages/my/StoreRegister.vue')
    },
  },
  {
    name: 'my/business/register',
    path: '/my/business/register',
    component() {
      return import('@/pages/my/BusinessRegister.vue')
    },
  },
  {
    name: 'my/account/register',
    path: '/my/account/register',
    component() {
      return import('@/pages/my/AccountRegister.vue')
    },
  },
  {
    name: 'my/malls',
    path: '/my/malls',
    component() {
      return import('@/pages/my/mall/Malls.vue')
    },
  },
  // 등록
  {
    name: 'my/malls/register',
    path: '/my/malls/form',
    component() {
      return import('@/pages/my/mall/MallsDetail.vue')
    },
  },
  // 수정
  {
    name: 'my/malls/detail',
    path: '/my/malls/:uuid/form',
    component() {
      return import('@/pages/my/mall/MallsUpdateForm.vue')
    },
  },
  //  2차인증
  {
    name: 'my/malls/two-factor-auth',
    path: '/my/malls/two-factor-auth',
    component() {
      return import('@/pages/my/mall/TwoFactorAuth.vue')
    },
    props: (route) => ({
      provider: route.query.provider,
      mallUuid: route.query.mallUuid,
      ...route.params,
    }),
  },
  {
    name: 'my/register/complete',
    path: '/my/register/complete',
    component() {
      return import('@/pages/my/RegisterComplete.vue')
    },
  },
  {
    name: 'my/contract/management',
    path: '/my/contract/management',
    component() {
      return import('@/pages/my/contract/ContractManagement.vue')
    },
  },
  {
    name: 'my/contract/:provider/info',
    path: '/my/contract/:provider/info',
    component() {
      return import('@/pages/my/contract/ContractProviderInfo.vue')
    },
  },
  {
    name: 'my/contract/embed/redirect',
    path: '/my/contract/embed/redirect',
    meta: {
      layout: 'EmptyLayout',
    },
    component() {
      return import('@/pages/my/contract/embed/Callback.vue')
    },
  },
  {
    name: 'my/histories/credit',
    path: '/my/histories/credit',
    component() {
      return import('@/pages/my/history/CreditHistory.vue')
    },
  },
  {
    name: 'my/plans',
    path: '/my/plans',
    meta: {
      ui: {
        bottomless: true,
        newHeader: true,
      },
    },
    component() {
      return import('@/pages/my/Plans.vue')
    },
  },
]
